import ColumnFilterContainer from '@/components/ColumnFilters/ColumnFilterContainer';
import type { ColumnFilterValue } from '@/models/flowFilter.type';
import { TextInput } from '@mantine/core';
import { useDebouncedCallback } from '@mantine/hooks';
import { useState } from 'react';

type TextColumnFilterProps = {
  label: string;
  value: ColumnFilterValue | undefined;
  onChange: (value: ColumnFilterValue | undefined) => void;
};

const DEBOUNCE_DELAY_MS = 400;

/** Filtre « contient » (insensible à la casse), appliqué après une courte pause de saisie. */
const TextColumnFilter = ({ label, value, onChange }: TextColumnFilterProps) => {
  const [text, setText] = useState(value?.kind === 'text' ? value.value : '');

  const commit = useDebouncedCallback((next: string) => {
    onChange(next.trim() ? { kind: 'text', value: next } : undefined);
  }, DEBOUNCE_DELAY_MS);

  return (
    <ColumnFilterContainer
      onReset={() => {
        setText('');
        onChange(undefined);
      }}
    >
      <TextInput
        autoComplete="off"
        label={label}
        value={text}
        onChange={event => {
          setText(event.currentTarget.value);
          commit(event.currentTarget.value);
        }}
      />
    </ColumnFilterContainer>
  );
};

export default TextColumnFilter;
